import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import { addUserValues } from "../../utils/formik/initialValues";
import { addUserSchema } from "../../utils/formik/validationSchema";
import { userManagementData } from "../../utils/tableData";
import DeleteConfirmContent from "../../components/modal-contents/DeleteConfirmModalContent";
import SubAdminApi from "../../services/subAdminService";
const CustomTable = Loadable(
  React.lazy(() => import("../../components/custom-table/CustomTable"))
);
const CustomModel = Loadable(
  React.lazy(() => import("../../components/custom-model/CustomModel"))
);
import Loadable from "../../components/Loadable";
import { notify } from "../../bmr/utils/methods/notification";
import EditorApi from "../../services/editorManagementService";
import HospitalApi from "../../services/hospitalService";
import ListDrawer from "../../components/ListDrawer/ListDrawer";
import SearchableDropdown from "../../components/SearchableDropdown/SearchableDropdown";
import CustomDrawer from "../../components/custom-drawer/CustomDrawer";
import HeaderBackNav from "../../components/header-back-navigation/HeaderBackNav";
import CustomSearchbar from "../../components/custom-searchbar/CustomSearchbar";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import NoDataCard from "../../components/no-data-card";
import { DoctorIcon } from "../../assets/products-svg/ProductSvg"; // Make sure to import DoctorIcon
import { Typography } from "@mui/material";

const normalizeCountryCode = (value) => {
  const code = String(value || "91").replace(/\D/g, "");
  return code || "91";
};

const convertUserData = (data) => {
  return data.map((userMangement) => {
    let transformedName = userMangement?.name;
    let transformeEmail = userMangement?.email;
    let transformedType = userMangement?.role;
    
    // Handle PI data properly - check both pi_ids and investigator_details
    let piData = userMangement?.pi_ids;
    let investigatorData = userMangement?.investigator_details;
    let transformedPi = "N/A";
    let piListData = [];
    
    // First check if there are multiple PIs in pi_ids
    if (piData && typeof piData === 'object' && Object.keys(piData).length > 0) {
      // Convert the object to array of PI objects
      piListData = Object.values(piData);
      transformedPi = piListData.length;
    } 
    // Then check if there's a single investigator
    else if (investigatorData && typeof investigatorData === 'object' && Object.keys(investigatorData).length > 0) {
      // investigator_details is a single object, not an object with keys
      piListData = [investigatorData];
      transformedPi = 1;
    }
    
    // Ensure each PI item has proper primitive values
    piListData = piListData.map(pi => ({
      id: pi.id,
      name: String(pi.name || ''),
      email: pi.email || '',
    }));
    
    let transformedAssigned = userMangement?.phaseCount;
    let phaseList = userMangement?.phaseDetails;
    let transformRowId = userMangement?.id;
    
    return {
      displayData: [
        transformedName,                    
        transformeEmail,                 
        transformedType,                 
        transformedPi,                 
        transformedAssigned,
        transformRowId, 
      ],
      internalData: {
        piListData,                        
        phaseList,                         
        rowId: transformRowId,             
        originalData: userMangement        
      }
    };
  });
};

export const UserManagement = () => {
  const [openAddModal, setOpenAddModal] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = React.useState(false);
  const [tableFilters, setTablesFilters] = useState({ searchData: "" });
  const [userMangement, setUserMangement] = useState(userManagementData);
  const [initialValues, setInitialValues] = useState(addUserValues);
  const [userManagementResponse, setUserManagementResponse] = useState([]);
  const [currentPage, setCurrentpage] = useState(1);
  const [rowId, setRowId] = useState(null);
  const [roleID, setRoleID] = useState("");
  const [newRoleIDs, setNewRoleIDs] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [deleteRowData, setDeleteRowData] = useState(null);
  const [roleDropDownId, setRoleDropDownId] = useState('');
  const [roleDropDownSlug, setroleDropDownSlug] = useState('');
  
  const [openDrawer, setOpenDrawer] = useState(false);
  const [phaseListData, setPhaseListData] = useState([]);
  const [openPiDrawer, setOpenPiDrawer] = useState(false);
  const [piListData, setPiListData] = useState([]);
  const [allHospitals, setAllHospitals] = useState([]);
  const [allPIs, setAllPIs] = useState([]);
  const [phaseList, setPhaseList] = useState([]);
  
  // New state for PI drawer search
  const [piSearch, setPiSearch] = useState("");

  const [modelData, setModelData] = useState({
    title: "Add User",
    editTitle: "Edit User",
    children: [
      {
        type: "dropdown",
        name: "userType",
        label: "User Type",
        placeholder: "Enter Type",
        data: roleList,
        IsRequired: true,
      },
      {
        type: "input",
        name: "name",
        label: "Name",
        placeholder: "Enter Name",
        IsRequired: true,
      },
      {
        type: "input",
        name: "email",
        label: "Email",
        placeholder: "Enter Email",
        IsRequired: true,
      },
      {
        type: "phone",
        name: "phoneNumber",
        label: "Phone Number",
        placeholder: "Enter Phone Number",
        countryCodeName: "countryCode",
        defaultCountry: "in",
        IsRequired: true,
      },
    ],
  });

useEffect(() => {
  if (openAddModal || openEditModal) {
    // For role ID 5, always load all PIs
    if (roleDropDownId == 5) {
      getPersonalInvestigatorList();
    }
    // For project manager, only load PIs if hospitals are already selected (edit mode)
    else if (roleDropDownSlug === 'project-manager' && initialValues?.hospital?.length > 0) {
      const hospitalIds = initialValues.hospital.map(h => h.id);
      EditorApi.getPIByHospitalIds({
        hospital_ids: hospitalIds
      })
        .then((res) => {
          const piOptions = res?.data?.map((pi) => ({
            id: pi.id,
            name: pi.name,
            label: pi.name
          }));
          setAllPIs(piOptions);
        })
        .catch((error) => {
          notify.error(error);
          setAllPIs([]);
        });
    }
  }
}, [openAddModal, openEditModal, roleDropDownId, roleDropDownSlug, initialValues?.hospital]);

 useEffect(() => {
  const newChildren = [
    {
      type: "input",
      name: "name",
      label: "Name",
      placeholder: "Enter Name",
      IsRequired: true,
    },
    {
      type: "phone",
      name: "phoneNumber",
      label: "Phone Number",
      placeholder: "Enter Phone Number",
      countryCodeName: "countryCode",
      defaultCountry: "in",
      IsRequired: true,
    },
  ];
  
  if (rowId == "") {
    newChildren.push({
      type: "input",
      name: "email",
      label: "Email",
      placeholder: "Enter Email",
      IsRequired: true,
    });
    newChildren.unshift({
      type: "dropdown",
      name: "userType",
      label: "User Type",
      placeholder: "Enter Type",
      data: roleList,
      IsRequired: true,
    });
  } else {
    newChildren.push({
      type: "input",
      name: "email",
      label: "Email",
      placeholder: "Enter Email",
      IsRequired: true,
      disabled: true,
    });
    newChildren.unshift({
      type: "dropdown",
      name: "userType",
      label: "User Type",
      placeholder: "Enter Type",
      data: roleList,
      IsRequired: true,
      disabled: true,
    });
  }

  // FIX: Show PI and Phase fields for both role ID 5 AND Editor role
  const shouldShowPiAndPhase = roleDropDownId == 5 || roleDropDownSlug === 'editor';
  
  if (shouldShowPiAndPhase) {
    // For role ID 5, show PI dropdown with current allPIs state
    newChildren.push({
      type: "component",
      name: "principalInvestigator",
      label: "Principal Investigator/HCP",
      placeholder: "Select Principal Investigator/HCP",
      IsRequired: true,
      component: SearchableDropdown,
      props: {
      options: Array.isArray(allPIs) ? allPIs : [],
      multiple: false,
      placeholder: "Search principal investigators/HCP...",
      label: "Principal Investigator/HCP",
      required: true,
     filterOptions: (options, state) => {
        if (!state.inputValue.trim()) return options;
        
        const searchLower = state.inputValue.toLowerCase().trim();
        return options.filter(option => {
          const name = option?.name || option?.label || "";
          const email = option?.email || "";
          
          // Exact matching - you can adjust the logic as needed
          return (
            name.toLowerCase().includes(searchLower) ||
            email.toLowerCase().includes(searchLower)
          );
        });
      }
      // FIX: Add search functionality
    }
    },
    {
      type: "multidropdown",
      name: "trial",
      label: "Phase",
      placeholder: "Select Phase",
      data: phaseList,
      IsRequired: true,
    });
  } 
  else if (roleDropDownSlug == 'project-manager') {
    // For project manager, show hospitals first, then PIs
    newChildren.push({
      type: "component",
      name: "hospital",
      label: "Hospital/Site",
      IsRequired: true,
      component: SearchableDropdown,
      props: {
        options: Array.isArray(allHospitals) ? allHospitals : [],
        multiple: true,
        placeholder: "Search hospitals/Site...",
        label: "Hospital/Site",
        required: true
      }
    });

    // FIX: For project manager, initially show empty PI options until hospitals are selected
    const shouldShowPIs = roleDropDownSlug === 'project-manager' && 
                         initialValues?.hospital?.length > 0;
    
    newChildren.push({
      type: "component",
      name: "principalInvestigator",
      label: "Principal Investigator/HCP",
      placeholder: shouldShowPIs ? "Search principal investigators/HCP..." : "Please select hospitals/site first",
      IsRequired: true,
      component: SearchableDropdown,
      props: {
        options: shouldShowPIs ? (Array.isArray(allPIs) ? allPIs : []) : [],
        multiple: true,
        placeholder: shouldShowPIs ? "Search principal investigators/HCP..." : "Please select hospitals/site first",
        label: "Principal Investigator/HCP",
        required: true,
        disabled: !shouldShowPIs // Disable if no hospitals selected
      }
    });
  }
  else if (roleDropDownId == 2) {
    // KEEP as regular dropdown for single selection
    newChildren.push({
      type: "dropdown",
      name: "hospital",
      label: "Hospital/Site",
      placeholder: "Select Hospital/Site",
      IsRequired: true,
      data: allHospitals,
    });
  }

  setModelData((prevModelData) => ({
    ...prevModelData,
    children: newChildren,
  }));
}, [roleDropDownId, rowId, roleDropDownSlug, roleList, allHospitals, allPIs, phaseList, initialValues?.hospital]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.openAddUserModal) {
      handleOpenAddModal();
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  const getPersonalInvestigatorList = () =>
    EditorApi.subadminDropDown()
      .then((res) => {
        const piData = res.data.map(pi => ({
          ...pi,
          label: pi.name
        }));
        setAllPIs(piData);
      })
      .catch((error) => {
        notify.error(error)
      });

  const getPhase = (piId) => {
    EditorApi.getPhaseDropDown('', piId)
      .then((res) => {
        const data = res?.data?.map((val) => ({
          id: val.id,
          name: `${val.title}(${val.product_details?.name})`,
        }));
        setPhaseList(data || []);
        setModelData((prevState) => ({
          ...prevState,
          children: prevState.children.map((child) =>
            child.name === "trial" ? { ...child, data: data || [] } : child
          ),
        }));
      })
      .catch((error) => {
        notify.error(error);
        setPhaseList([]);
      });
  };

  const getHospitalList = () => {
    return HospitalApi.getHospitalData('', 1, '')
      .then((res) => {
        const rowData = res?.data?.map((list) => {
          return {
            id: list?.id,
            name: list?.name + ' ' + `(${list?.city_name})`,
            label: list?.name + ' ' + `(${list?.city_name})`
          };
        });
        setAllHospitals(rowData);
      })
      .catch((error) => {
        notify.error(error)
      });
  };

  const handleNavigateToDetails = React.useCallback((rowData) => {
  
  
  const rowIndex = userMangement?.rows?.indexOf(rowData) ?? -1;
  
  if (rowIndex !== -1) {
    const internalData = userManagementResponse?.[rowIndex]?.internalData;
    
    
    if (internalData?.rowId) {
      navigate(`onboard-users-details/${internalData.rowId}`);
      return;
    }
  }
  
  if (rowData && rowData.length > 0) {
    // If you modified convertUserData to include ID as last element
    const possibleRowId = rowData[rowData.length - 1];
    if (possibleRowId && typeof possibleRowId === 'number') {
      navigate(`onboard-users-details/${possibleRowId}`, {
        state: { from: "user-management" }
      });
      return;
    }
  }
  
  notify.error("Unable to navigate: User data not available")
}, [navigate, userMangement?.rows, userManagementResponse]);

  useEffect(() => {
    getSubAdminListByRoles();
    getPersonalInvestigatorList();
    getHospitalList();
  }, []);

  useEffect(() => {
    if (
      (tableFilters?.searchData &&
        tableFilters?.searchData[tableFilters?.searchData?.length - 1] != " ") ||
      newRoleIDs?.length > 0
    ) {
      setLoading(true);
      getSubAdminList();
    }
  }, [currentPage, tableFilters, roleID, newRoleIDs]);

  const getSubAdminListByRoles = () =>
    SubAdminApi.getSubAdminListByRoles().then((res) => {
      const dataList = res?.data?.map((list) => ({
        id: list?.id,
        name: list?.title,
        slug: list?.slug,
      }));
      setNewRoleIDs(dataList?.map((val) => val.id));
      setRoleList(dataList);
    });

  const getSubAdminList = () => {
    SubAdminApi.getSubAdminData(
      10,
      currentPage,
      tableFilters?.searchData,
      roleID
    )
      .then((res) => {
        let convertedData = convertUserData(res?.data || []);
        
        let rowData = convertedData.map(item => item.displayData);
        
        setUserManagementResponse(convertedData);
        
        setUserMangement((prev) => ({
          ...prev,
          rows: [...rowData],
        }));

        setTotalPage(
          Math.ceil(res?.page_details?.no_of_records / res?.page_details?.limit)
        );
        setCurrentpage(res?.page_details?.page);
        setLoading(false);
      })
      .catch((error) => {
        notify.error(error)
        setLoading(false);
      });
  };

const handleOpenAddModal = () => {
  const baseValues = {
    ...addUserValues,
    hospital: [],
    principalInvestigator: roleDropDownId == 5 ? null : [],
    trial: [],
    slug: roleDropDownSlug || '', // Ensure it's always set, even if empty
    userType: ''
  };

  setInitialValues(baseValues);
  setRowId("");
  setOpenAddModal(true);
  setRoleDropDownId('');
  setroleDropDownSlug('');
  setAllPIs([]);
};

const handleOpenEditPrincipalModal = async (row, rowIndex) => {
  if (userManagementResponse && userManagementResponse[rowIndex]) {
    const internalData = userManagementResponse[rowIndex]?.internalData;
    const rowId = internalData?.rowId;
    
    setRowId(rowId);
    const originalData = internalData?.originalData;

    await Promise.all([
      getHospitalList(),
      getPersonalInvestigatorList()
    ]);

    // FIXED: Comprehensive hospital data extraction for ALL roles
    let hospitalValue = null;
    
    // For role ID 2 (dropdown - single select), we need a single ID, not an array
    if (originalData?.role_id == 2) {
      // For dropdown, we need the hospital ID directly
      if (originalData?.hospital_id) {
        hospitalValue = originalData.hospital_id;
      } else if (originalData?.phase_all_hospital?.length > 0) {
        // Take the first hospital if multiple exist
        hospitalValue = originalData.phase_all_hospital[0]?.id;
      }
    } else {
      // For other roles that use SearchableDropdown (multiple select), we need array of objects
      let hospitalObjects = [];
      const hospitalIds = [];
      
      // Check ALL possible sources for hospital data
      // Source 1: hospital_id field
      if (originalData?.hospital_id) {
        if (Array.isArray(originalData.hospital_id)) {
          hospitalIds.push(...originalData.hospital_id.filter(id => id));
        } else if (typeof originalData.hospital_id === 'number' || typeof originalData.hospital_id === 'string') {
          hospitalIds.push(originalData.hospital_id);
        }
      }
      
      // Source 2: phase_all_hospital array
      if (originalData?.phase_all_hospital?.length > 0) {
        const ids = originalData.phase_all_hospital
          .filter(hospital => hospital && hospital.id)
          .map(hospital => hospital.id);
        hospitalIds.push(...ids);
      }

      // Remove duplicates and filter available hospitals
      const uniqueHospitalIds = [...new Set(hospitalIds.filter(id => id))];
      
      hospitalObjects = allHospitals.filter(hospital => 
        uniqueHospitalIds.includes(hospital.id)
      );
      hospitalValue = hospitalObjects;
    }

    // FILTER PIs BASED ON SELECTED HOSPITALS
    let filteredPIs = allPIs;
    if (hospitalValue && originalData?.role_details?.slug === "project-manager") {
      try {
        const hospitalIds = Array.isArray(hospitalValue) 
          ? hospitalValue.map(h => h.id) 
          : [hospitalValue];
        const res = await EditorApi.getPIByHospitalIds({
          hospital_ids: hospitalIds
        });
        filteredPIs = res?.data?.map((pi) => ({
          id: pi.id,
          name: pi.name,
          label: pi.name
        })) || [];
      } catch (error) {
        notify.error(error)
        filteredPIs = allPIs;
      }
    }

    const principalInvestigatorIds = originalData?.pi_ids && Object.keys(originalData.pi_ids).length > 0
      ? Object.values(originalData.pi_ids).map(pi => pi.id)
      : originalData?.investigator_details?.id
        ? [originalData.investigator_details.id]
        : [];
    
    const piObjects = filteredPIs.filter(pi => 
      principalInvestigatorIds.includes(pi.id)
    );


    const editValues = {
      userType: originalData?.role_id,
      name: originalData?.name,
      email: originalData?.email,
      countryCode: normalizeCountryCode(originalData?.country_code),
      phoneNumber: originalData?.phone,
      selectTrial: originalData?.phase_id,
      hospital: hospitalValue, // This will be ID for role 2, array of objects for others
      principalInvestigator: originalData?.role_id == 5 ? (piObjects[0] || null) : piObjects,
      trial: originalData?.phaseDetails?.map(item => item.id) || [],
      slug: originalData?.role_details?.slug
    };

    setInitialValues(editValues);
    
    setOpenEditModal(true);
    setRoleDropDownId(originalData?.role_id);
    setroleDropDownSlug(originalData?.role_details?.slug);
    
    setAllPIs(filteredPIs);
    
    if (originalData?.investigator_details?.id) {
      getPhase(originalData?.investigator_details?.id);
    }
  }
};

const handleAddModelValues = async (values) => {
  setSubmitLoading(true);
  
  // FIX: Handle hospital data properly for dropdown
  let hospitalIds = [];
  if (roleDropDownId == 2) {
    // For role ID 2, we need a single hospital ID, not an array
    if (Array.isArray(values?.hospital)) {
      // Take the first hospital if multiple are selected (shouldn't happen for role ID 2)
      hospitalIds = values.hospital[0]?.id || values.hospital[0];
    } else if (values?.hospital) {
      // For single selection - extract ID if it's an object, or use directly if it's already an ID
      hospitalIds = typeof values.hospital === 'object' ? values.hospital.id : values.hospital;
    }
  } else {
    // For other roles, keep the existing array logic
    hospitalIds = Array.isArray(values?.hospital) 
      ? values.hospital.filter(h => h && h.id).map(h => h.id) 
      : values?.hospital?.id 
        ? [values.hospital.id] 
        : [];
  }

  const piIds = Array.isArray(values?.principalInvestigator) 
    ? values.principalInvestigator.filter(pi => pi && pi.id).map(pi => pi.id)
    : values?.principalInvestigator?.id 
      ? [values.principalInvestigator.id] 
      : [];

  const phaseIds = Array.isArray(values?.trial) 
    ? values.trial
    : [];

  const submitData = {
    name: values?.name || '',
    email: values?.email || '',
    country_code: normalizeCountryCode(values?.countryCode),
    phone: values?.phoneNumber?.toString() || '',
    role_id: values?.userType || '',
  };

  // FIX: For role ID 2, send hospital_id as single integer
  if (roleDropDownId == 5) {
    if (phaseIds.length > 0) submitData.phase_ids = phaseIds;
    if (piIds.length > 0) submitData.investigator_id = piIds[0];
  }
  
  // FIX: This condition was missing hospital data - send as single integer for role ID 2
  if (roleDropDownId == 2 && hospitalIds) {
    submitData.hospital_id = hospitalIds; // This will now be a single integer, not an array
  }
  
  if (roleDropDownSlug === "project-manager") {
    if (hospitalIds.length > 0) {
      submitData.hospital_id = hospitalIds;
    }
    if (piIds.length > 0) {
      submitData.investigator_id = piIds;
    }
  }


  SubAdminApi.addSubAdmin(submitData)
    .then((res) => {
      if (res?.status === 200) {
        getSubAdminList();
        notify.success(res.message)
        setOpenAddModal(false);
        setSubmitLoading(false);
      }
    })
    .catch((error) => {
      notify.success(error)
      setSubmitLoading(false);
    });
};

const handleEditModelValues = (values) => {
  const subAdminEditData = userManagementResponse.find((userMangement) => {
    return userMangement.internalData.rowId == rowId;
  });
  
  // FIX: Handle hospital data extraction properly for role ID 2
  let hospitalIds = null;
  if (values?.hospital) {
    if (roleDropDownId == 2) {
      // For role ID 2, extract single hospital ID
      if (Array.isArray(values.hospital)) {
        hospitalIds = values.hospital[0]?.id || values.hospital[0];
      } else if (typeof values.hospital === 'object' && values.hospital !== null) {
        hospitalIds = values.hospital.id;
      } else if (typeof values.hospital === 'number' || typeof values.hospital === 'string') {
        hospitalIds = values.hospital;
      }
    } else {
      // For other roles, keep array logic
      if (Array.isArray(values.hospital)) {
        hospitalIds = values.hospital
          .filter(h => h && (h.id || typeof h === 'number'))
          .map(h => h.id || h);
      } else if (typeof values.hospital === 'object' && values.hospital !== null) {
        hospitalIds = [values.hospital.id];
      } else if (typeof values.hospital === 'number' || typeof values.hospital === 'string') {
        hospitalIds = [values.hospital];
      }
    }
  }

  const piIds = Array.isArray(values?.principalInvestigator) 
    ? values.principalInvestigator.filter(pi => pi && pi.id).map(pi => pi.id)
    : values?.principalInvestigator?.id 
      ? [values.principalInvestigator.id] 
      : [];

  const phaseIds = Array.isArray(values?.trial) 
    ? values.trial
    : [];

  const dataIds = subAdminEditData?.internalData?.originalData?.phaseDetails?.map(item => item.id) || [];
  const missingIds = dataIds?.filter(id => !phaseIds.includes(id));
  
  const originalInvestigatorId = subAdminEditData?.internalData?.originalData?.investigator_details?.id;
  const isInvestigator = originalInvestigatorId && originalInvestigatorId !== (piIds[0] || null) 
    ? originalInvestigatorId 
    : 0;

  const submitData = {
    name: values?.name || '',
    email: values?.email || '',
    country_code: normalizeCountryCode(values?.countryCode),
    phone: values?.phoneNumber?.toString() || '',
    role_id: values?.userType || '',
  };

  // FIX: For role ID 2, send hospital_id as single integer
  if (roleDropDownId == 2 && hospitalIds) {
    submitData.hospital_id = hospitalIds; // Single integer, not array
  }
  
  if (roleDropDownId == 5) {
    if (phaseIds.length > 0) submitData.phase_ids = phaseIds;
    if (piIds.length > 0) submitData.investigator_id = piIds[0];
    if (missingIds.length > 0) submitData.removedPhaseIds = missingIds;
    if (isInvestigator) submitData.removedInvestigatorId = isInvestigator;
  }
  
  if (roleDropDownSlug === "project-manager") {
    if (hospitalIds && hospitalIds.length > 0) {
      submitData.hospital_id = hospitalIds;
    }
    if (piIds.length > 0) {
      submitData.investigator_id = piIds;
    }
  }

  
  setSubmitLoading(true);
  SubAdminApi.editSubAdmin(submitData, rowId)
    .then((res) => {
      if (res.status === 200) {
        getSubAdminList();
        notify.success(res.message)
        setOpenEditModal(false);
        setSubmitLoading(false);
      }
    })
    .catch((error) => {
        notify.error(error)
      setSubmitLoading(false);
    });
};

  const handleOpenDeleteConfirmModal = (row) => {
    setOpenDeleteConfirmModal(true);
    setDeleteRowData(row);
  };

  const handlePagination = (value) => {
    setCurrentpage(value);
  };

  const handleTableFilters = (e) => {
    setTablesFilters({ ...tableFilters, searchData: e });
    setCurrentpage(1);
  };

  const handleDeleteRow = () => {
    setSubmitLoading(true);
    SubAdminApi.deleteSubAdmin(deleteRowData[deleteRowData?.length - 1])
      .then((res) => {
        if (res?.status === 200) {
          getSubAdminList();
          notify.success(res?.message)
          setOpenDeleteConfirmModal(false);
          setSubmitLoading(false);
        }
      })
      .catch((error) => {
        notify.error(error)
        setSubmitLoading(false);
        setOpenDeleteConfirmModal(false);
      });
  };

  const handleRoleIdChange = (e) => {
    setRoleID(e.target.value);
    setCurrentpage(1);
  };

const handleModelData = (e, name, pi, setFieldValue) => {
  
  if (name == "userType") {
    setRoleDropDownId(e);
    const selectedRole = roleList.find((role) => String(role.id) === String(e));
    if (selectedRole) {
      const newSlug = selectedRole.slug || '';
      setroleDropDownSlug(newSlug);
      
      if (setFieldValue) {
        setFieldValue('slug', newSlug);
        setFieldValue('userType', e);
        setFieldValue('hospital', []);
        setFieldValue('principalInvestigator', newSlug === 'project-manager' ? [] : null);
        setFieldValue('trial', []);
      }
      
      setInitialValues(prev => ({
        ...prev,
        userType: e,
        slug: newSlug,
        hospital: [],
        principalInvestigator: newSlug === 'project-manager' ? [] : null,
        trial: []
      }));

      if (newSlug === 'project-manager') {
        setAllPIs([]);
      } else if (e == 5) {
        getPersonalInvestigatorList();
      }
    }
  }
  
  // FIX: Handle hospital field updates for project manager role
  if (name === "hospital" && roleDropDownSlug === 'project-manager') {
    
    const selectedHospitals = Array.isArray(e) ? e : [e];
    
    // Update form values immediately
    if (setFieldValue) {
      setFieldValue('hospital', e);
    }
    
    setInitialValues(prev => ({
      ...prev,
      hospital: e
    }));

    // If no hospitals selected, clear PIs
    if (selectedHospitals.length === 0 || !selectedHospitals[0]?.id) {
      setAllPIs([]);
      if (setFieldValue) {
        setFieldValue('principalInvestigator', []);
      }
      setInitialValues(prev => ({
        ...prev,
        principalInvestigator: []
      }));
      return;
    }

    // Get hospital IDs for API call
    const hospitalIds = selectedHospitals.map(h => h.id).filter(id => id);

    // Call API to get PIs for selected hospitals
    EditorApi.getPIByHospitalIds({ hospital_ids: hospitalIds })
      .then((res) => {
        const piOptions = res?.data?.map((pi) => ({
          id: pi.id,
          name: pi.name,
          label: pi.name,
          email: pi.email || ''
        })) || [];
        
        setAllPIs(piOptions);
        
        // Filter current selected PIs to only keep those that are in the new PI list
        const currentPIs = Array.isArray(initialValues?.principalInvestigator) 
          ? initialValues.principalInvestigator 
          : [];
        
        if (currentPIs.length > 0) {
          const validPIs = currentPIs.filter(currentPI => 
            piOptions.some(validPI => validPI.id === currentPI.id)
          );
          
          // If some PIs were removed due to hospital change, update the form
          if (validPIs.length !== currentPIs.length) {
            if (setFieldValue) {
              setFieldValue('principalInvestigator', validPIs);
            }
            setInitialValues(prev => ({
              ...prev,
              principalInvestigator: validPIs
            }));
          }
        }
      })
      .catch((error) => {
        notify.error(error)
        setAllPIs([]);
        // Clear PIs on error
        if (setFieldValue) {
          setFieldValue('principalInvestigator', []);
        }
        setInitialValues(prev => ({
          ...prev,
          principalInvestigator: []
        }));
      });
    return;
  }
  
  // Handle hospital changes for other roles (non-project manager)
  if (name === "hospital" && roleDropDownSlug !== 'project-manager') {
    if (setFieldValue) {
      setFieldValue('hospital', e);
    }
    setInitialValues(prev => ({
      ...prev,
      hospital: e
    }));
    return;
  }
  
  if (pi == "principalInvestigator" || name === "principalInvestigator") {
    const piId = e?.id || e;
    if (setFieldValue) {
      setFieldValue('trial', []);
    }
    
    setInitialValues(prev => ({
      ...prev,
      principalInvestigator: e,
      trial: [] 
    }));
    
    if (piId) {
      getPhase(piId);
    } else {
      setPhaseList([]);
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "trial" ? { ...child, data: [] } : child
        ),
      }));
    }
    return;
  }
  
  // For trial/phase selection (no  handling needed)
  if (name === "trial") {
    if (setFieldValue) {
      setFieldValue(name, e);
    }
    setInitialValues(prev => ({
      ...prev,
      [name]: e
    }));
  }
};

  const handleCellClick = (row, columnIndex) => {
    const rowIndex = getRowIndex(row);
    if (!userManagementResponse || !userManagementResponse[rowIndex]) {
      console.log("No user management response data available");
      return;
    }

    const internalData = userManagementResponse[rowIndex]?.internalData;
    
      const piCountIndex = row.length - 3;
    const phaseCountIndex = row.length - 2;
    
    if (columnIndex === piCountIndex) {
      const piListData = internalData?.piListData || [];
      if (piListData.length > 0) {
        setPiListData(piListData);
        setOpenPiDrawer(true);
      } else {
        // notify.info("No Principal Investigators assigned");
      }
    } 
    else if (columnIndex === phaseCountIndex) {
      const phaseListData = internalData?.phaseList || [];
      if (phaseListData.length > 0) {
        setPhaseListData(phaseListData);
        setOpenDrawer(true);
      } else {
        // dispatch(setSnackbar({ value: true, message: info, color: "error" }));

        // notify.info("No phases assigned");
      }
    }
  };

  const getRowIndex = (row) => {
    return userMangement?.rows?.indexOf(row) ?? -1;
  };

  // Filter PI list based on search
  const filteredPiListData = piListData.filter(pi => 
    pi.name.toLowerCase().includes(piSearch.toLowerCase())
  );

  return (
    <>
      <div className="flex flex-col gap-0 bg-white p-0 !pb-0">
        <CustomModel
          rowId={rowId}
          modalInitialValues={initialValues}
          initialValuesValidationSchema={addUserSchema}
          open={openEditModal ? openEditModal : openAddModal}
          setOpen={openEditModal ? setOpenEditModal : setOpenAddModal}
          setModelData={setModelData}
          modelData={modelData}
          isLoadingBtn={submitLoading}
          handleModelValues={
            openEditModal ? handleEditModelValues : handleAddModelValues
          }
         onChange={(e, name, pi, setFieldValue) => handleModelData(e, name, pi, setFieldValue)}
        />
        <CustomTable
          rows={userMangement?.rows}
          columnAlign={userMangement?.columnAlign}
          columns={userMangement?.columns}
          TableData={userMangement?.TableData}
          handleNavigate={handleNavigateToDetails}
          handleButtonClick={handleOpenAddModal}
          handleEditButton={(row) => {
            const rowIndex = getRowIndex(row);
            handleOpenEditPrincipalModal(row, rowIndex);
          }}
          handleDeleteButton={handleOpenDeleteConfirmModal}
          handleTableFilters={handleTableFilters}
          tableFilters={tableFilters}
          handleChangePage={handlePagination}
          handleChangeDropDown={handleRoleIdChange}
          dropDownValue={roleID}
          MenuList={roleList}
          loading={loading}
          currentPage={currentPage}
          totalpage={totalPage}
          handleCellClick={(row, columnIndex) => {
            handleCellClick(row, columnIndex);
          }}
        />
      </div>
      <DeleteConfirmContent
        open={openDeleteConfirmModal}
        setOpen={setOpenDeleteConfirmModal}
        handleDelete={handleDeleteRow}
        isLoading={submitLoading}
      />
      
      {/* Phase List Drawer */}
      {openDrawer && (
        <ListDrawer
          open={openDrawer}
          toggleDrawer={() => setOpenDrawer(!openDrawer)}
          listData={phaseListData || []}
          title="Phase List"
        />
      )}
      
      {/* PI List Drawer - Using the same UI as TrailManagement */}
      {openPiDrawer && (
        <CustomDrawer open={openPiDrawer} toggleDrawer={() => setOpenPiDrawer(!openPiDrawer)}>
          <div className="w-[25rem]">
            <div className="pl-4 pt-4 pr-4">
              <HeaderBackNav
                handleBackNav={() => setOpenPiDrawer(false)}
                TitleFontSize={"18px"}
                TitleFontWeight={700}
                Title="Principal Investigators/HCP"
              />
            </div>
            <hr />
            <div className="pl-3 pt-3 pr-3">
              <CustomSearchbar
                Placeholder="Search by Name"
                BgColor="#dfe0eb"
                value={piSearch}
                handleSearch={(value) => setPiSearch(value)}
              />
              <ul className="p-2 cursor-pointer">
                {loading ? (
                  <SkeletonLoader rowCount={5} height={"35px"} />
                ) : filteredPiListData?.length === 0 ? (
                  <div className="mt-4">
                    <NoDataCard />
                  </div>
                ) : (
                  filteredPiListData?.map((pi, index) => (
                    <li
                      key={pi?.id || index}
                      className="flex gap-3 align-center pt-2 pb-2"
                      style={{ borderBottom: "2px solid #dfe0eb" }}
                    >
                      <div className="self-center">
                        <DoctorIcon />
                      </div>
                      <div className="self-center">
                        <Typography variant="h6">
                          {pi?.name || "Name not available"}
                        </Typography>
                        {pi?.email && (
                          <Typography variant="body2" color="textSecondary">
                            {pi.email}
                          </Typography>
                        )}
                      </div>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        </CustomDrawer>
      )}
    </>
  );
};